import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../app/api'

const initialState = {
    clients: [],
    loading: false,
    error: null,
};

export const addClient = createAsyncThunk(
    'clients/addClient',
    async ({
        name, eik, ddsNumber, country, city, address, mol, email, company_id
    }, { rejectWithValue }) => {
        try {
            const response = await api.post('/clients/addClient', {
                name, eik, ddsNumber, country, city, address, mol, email, company_id
             });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }   
);

export const getUserClients = createAsyncThunk(
    'clients/getUserClients',
    async (dispatch, { rejectWithValue }) => {
        try {
            const response = await api.post('/clients/getUserClients', {
                company_id: dispatch.company_id 
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }   
);

export const editClient = createAsyncThunk(
    'clients/editClient',
    async ({ id, name, eik, ddsNumber, country, city, address, mol, email, phone }, { rejectWithValue }) => {
        try {
            const response = await api.put(`/clients/editClient/${id}`, {
                name, eik, ddsNumber, country, city, address, mol, email, phone
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const deleteClient = createAsyncThunk(
    'clients/deleteClient',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/clients/deleteClient/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

const clientsSlice = createSlice({
    name: 'clients',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(addClient.pending, (state) => {
                state.loading = true;
            })
            .addCase(addClient.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addClient.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            })
            .addCase(getUserClients.pending, (state) => {
                state.loading = true;
            })
            .addCase(getUserClients.fulfilled, (state, action) => {
                state.clients = action.payload.clients;
                state.loading = false;
            })
            .addCase(getUserClients.rejected, (state, action) => {
                state.error = action.payload;
                state.clients = [];
                state.loading = false;
            })
            .addCase(editClient.pending, (state) => {
                state.loading = true;
            })
            .addCase(editClient.fulfilled, (state, action) => {
                state.loading = false;
                if (state.clients) {
                    const index = state.clients.findIndex(client => client.id === action.payload.client.id);
                    if (index !== -1) {
                        state.clients[index] = action.payload.client;
                    }
                }
            })
            .addCase(editClient.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            })
            .addCase(deleteClient.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteClient.fulfilled, (state, action) => {
                state.loading = false;
                if (state.clients) {
                    state.clients = state.clients.filter(client => client.id !== action.payload.id);
                }
            })
            .addCase(deleteClient.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            });
    }
});

export default clientsSlice.reducer;